var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.multiType)?_c('div',[_c('show-more-cell',{attrs:{"row":_vm.row,"showElliptical":true,"show":_vm.column.commissionShow}})],1):_c('div',{staticClass:"fz-12"},[_vm._v("\n\t\t"+_vm._s(_vm.row.serviceRate)+"%\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }